import Icon from '../icon'
import React, { Component } from 'react'
import PropTypes from 'prop-types'

import ModeIcon from '../../icons/mode-icon'
import ViewTripButton from '../../viewers/view-trip-button'
import ViewStopButton from '../../viewers/view-stop-button'

import { formatDuration, formatTime } from '../../../@opentripplanner/core-utils/src/time'
import i18n from "../../../../i18nSetup";
import Box from '@mui/material/Box';
import { Alert, AlertTitle } from '@mui/lab';
import {rewriteHeadsign} from '../../../actions/ui'
import Grid from '@mui/material/Grid';
import SchedulesButton from "../../viewers/schedules-button";
import {connect} from "react-redux";


class TransitLeg extends Component {
  static propTypes = {
    itinerary: PropTypes.object
  }

  constructor(props) {
    super(props)
    this.state = {
      expanded: false,
      alertsExpanded: new Set()
    }
  }

  _onLegClick (e, leg, index) {
    if (this.props.active) {
      this.props.setActiveLeg(null)
    } else {
      this.props.setActiveLeg(index, leg)
    }
  }

  _onClick = () => {
    this.setState({expanded: !this.state.expanded})
  }

  getStopsTimes(leg) {
    const {stops} = this.props;

    let now = new Date().getTime();
    let firstTransitLeg = leg;

    if ((firstTransitLeg.startTime - now) > (60 * 20 * 1000)) {
      return null
    }

    let boardingStop = stops[firstTransitLeg.from.stopId];
    if (!boardingStop || !boardingStop.stopTimes)
      return null;

    let stopTimes = [];
    boardingStop.stopTimes.forEach((stopTime, i) => {
      if (firstTransitLeg.routeIds.includes(stopTime.pattern.route.id.replace("1:",""))) {
        stopTimes.push(...stopTime.times)
      }
    });

    if (!stopTimes.length)
      return null;
    return stopTimes;
  }
  renderRouteRows(leg,index,tripLineColor, travelDate) {
    if (!leg.shortNames || leg.shortNames.length < 2 || leg.mode == 'RAIL') {
      return (this.renderRouteRow(leg, index, tripLineColor, leg.routeShortName, leg.headsign, travelDate, leg.routeId))
    }

    let result = [];
    for (let i = 0; i < leg.shortNames.length; i++) {
      if (i > 0) {
        result.push((<div key={'shortname' + i} style={{paddingRight: 4, paddingLeft: 4}}>{i18n.t('or')}</div>))
      }
      result.push(this.renderRouteRow(leg, index, '#' + (leg.routeColors[i] || '000'), leg.shortNames[i], leg.headsigns[i], travelDate, leg.routeIds[i]))
    }
    return result;
  }

  renderRouteRow(leg, index, tripLineColor, routeShortName, headsign, travelDate, routeId,textColor) {

    let appendix = "";
    if(715 == leg.routeType){
      appendix += i18n.t('ADVANCED_BOOKING_REQUIRED')
    }
    return (
      <Grid key={'leg-grid-' + index + routeId} container spacing={3}>
        <Grid item xs={12}>
          <button
            key={'leg-button-' + index}
            className={`header`}
            style={{display: 'flex', alignItems: 'center', alignContent: 'center'}}
            onClick={(e) => this._onLegClick(e, leg, index)}
          >
            <div className='mode-icon-container'>
              <ModeIcon mode={leg.mode} agencyName={leg.agencyName} />
            </div>

            <div className='route-name'>
              <div>
                {routeShortName &&
                <span className='short-name' style={{backgroundColor: tripLineColor}}>{routeShortName}</span>}
                {headsign && <span className='route-long-name'>{i18n.t('towards')} {rewriteHeadsign(headsign) + appendix}</span>}
              </div>
            </div>

          </button>
          <SchedulesButton fontSize={14} stopName={leg.from.name} stopId={leg.from.stopId} routeId={routeId}
                           lineColor={tripLineColor}
                           lineNumber={routeShortName && leg.mode !== 'RAIL' ? routeShortName : null}
                           targetTrip={headsign ? rewriteHeadsign(headsign) : null} travelDate={travelDate ?? null}
                           stopTimes={this.getStopsTimes(leg)}/>
        </Grid>
      </Grid>
)
  }

  //{leg.realTime ? (<Icon type='rss'   style={{color:'#038844',transform:(this.props.dir === 'rtl') ? 'scaleX(-1)': 'none'}} />): null}

  render () {
    const { active, index, leg, travelDate} = this.props
    const { expanded } = this.state
    const numStops = leg.to.stopIndex - leg.from.stopIndex - 1
    const tripLineColor = '#'+ (leg.routeColor || "000");
    return (
      <div key={'transit-leg-' + index}
        className={`leg${active ? ' active' : ''} transit-leg`}>
          <div style={{margin:4}}>{i18n.t('waitFor')}</div>
        {this.renderRouteRows(leg,index,tripLineColor, travelDate)}
        <div className='step-by-step'>
          <div className='transit-leg-body'>

            {/* 'from' Stop Row */}
            <div className='from-row'>
              <div className='time-cell'>{formatTime(leg.startTime)}</div>
              <div className='trip-line-cell'>
                <Box component="div" ml={0.7} className='trip-line-top' sx={{ backgroundColor: tripLineColor }} ></Box>
                <div className='stop-bubble' style={{ borderColor: tripLineColor }} />
              </div>
              <div className='stop-name-cell'>
              <div style={{fontSize:12}}>{i18n.t('departureStation')}</div>
                <Box component="span" sx={{marginTop:0,marginBottom:0}}>
                  {leg.from.name}
                </Box>
                <div style={{color:'grey',fontSize:12}}>
                {getSecondary(leg.from)}
                </div>
              </div>
            </div>

            {/* Trip Details Row (intermediate stops, alerts, etc.) ${getMapColor(leg.mode)} */}
            <div className='trip-details-row'>
              <div className='time-cell' />
              <div className='trip-line-cell'>
                <Box component="div" ml={0.7} className='trip-line-middle' style={{ backgroundColor: tripLineColor }} ></Box>
              </div>
              <div className='trip-details-cell'>
                {/* Intermediate Stops (expandable) */}
                <div className='intermediate-stops' style={{marginLeft:10,marginRight:10}}>
       

<div>
                      <button className='clear-button-formatting' style={{paddingTop:2,paddingBottom:2,paddingLeft:0,paddingRight:0,marginRight:0,marginLeft:0}}  onClick={this._onClick}>
                          <Icon type={`caret-${expanded ? 'down' : 'right'}`} />
                          <span className='transit-duration'>{formatDuration(leg.duration)}</span>
                          {' • '}
                          {numStops ? `${numStops} ${i18n.t('stops')}` : i18n.t('non-stop')}
                      </button>
  </div>

         

                  {/* Expanded Stops */}
                  {expanded &&
                      <div className='stop-list' style={{paddingLeft:6,paddingRight:6}}>
                        {leg.intermediateStops.map((s, i) => (
                          <div key={i} className='stop-item item'>
                            <div className='trip-line-stop' style={{ backgroundColor: tripLineColor }} />
                            <span className='stop-name'>{formatLocation(s.name)}</span>
                          </div>
                        ))}
                      </div>
                  }

<div>
      
      <ViewTripButton
          leg={leg}
          tripId={leg.tripId}
          fromIndex={leg.from.stopIndex}
          toIndex={leg.to.stopIndex}
          text={i18n.t('tripViewer')}
      />

</div>
                </div>

                {leg.alerts &&
                  <div>
                  
                        {leg.alerts.map((alert, i) => (
                          <Alert key={"alert_" + i} sx={{fontSize:14,marginTop:8,marginBottom:0}} severity="warning">
<AlertTitle sx={{fontSize:14,marginTop:0,marginBottom:0}}  onClick={() => {
  let alertsExpanded = this.state.alertsExpanded;
  if(alertsExpanded.has(i)){
    alertsExpanded.delete(i)
  }else{
    alertsExpanded.add(i)
  }
  
  this.setState({alertsExpanded})
}
  }>{alert.alertHeaderText}</AlertTitle>
                    {(this.state.alertsExpanded.has(i) && alert.alertDescriptionText) ? alert.alertDescriptionText : null}
                    {(this.state.alertsExpanded.has(i) && alert.alertUrl) ? (<a target='_blank' rel="noopener noreferrer" href={alert.alertUrl}>{i18n.t('MoreInfo')}</a>) : null}
                 </Alert>
                        ))}
                
                   
                  </div>
                }

                {/* General Info */}
                <div className='item info-item'>
                  <span className='agency-info'>{i18n.t('ServiceOperatedBy')} <a href={leg.agencyUrl}>{leg.agencyName}</a></span>
                  {
                    // route info included?
                    // <span className='route-info'><a target='_blank' href={leg.routeUrl}>Route information</a></span>
                  }
                </div>
              </div>
            </div>

            {/* 'to' stop row */}
            <div className='to-row'>
              <div className='time-cell'>{formatTime(leg.endTime)}</div>
              <div className='trip-line-cell'>
                <Box component="div" ml={0.7} className='trip-line-bottom' sx={{ backgroundColor: tripLineColor }} ></Box>
                <div className='stop-bubble' sx={{ borderColor: tripLineColor }} />
              </div>
              <div className='stop-name-cell'>
                <div style={{fontSize:12}}>{i18n.t('arrivalStation')}</div>
                <Box component="span"  sx={{marginTop:0,marginBottom:0}}>
                  {formatLocation(leg.to.name)}
                </Box>
                <div style={{color:'grey',fontSize:12}}>
                {getSecondary(leg.to)}
                </div>
           
              </div>
            </div>

          </div>
        </div>
      </div>
    )
  }
}

/*       <span>
                  <ViewStopButton text={i18n.t('stopViewer')} stopId={leg.to.stopId} />
                  </span>*/

function getSecondary(location){
  let parts = [];
  if(location.stopCode){
    parts.push("#" + location.stopCode);
  }

  if(location.formatted_address){
    parts.push(location.formatted_address)
  }

  return parts.join (" | ");

}
function formatLocation (str) {
  return str
    .trim()
    .toLowerCase()
    .replace('/', ' / ')
    .replace('-', ' - ')
    .replace('@', ' @ ')
    .replace('(', '( ')
    .replace('  ', ' ')
    .split(' ')
    .map(s => {
      if (['ne', 'sw', 'nw', 'se'].includes(s)) return s.toUpperCase()
      return capitalizeFirst(s)
    })
    .join(' ')
    .replace('( ', '(')
}

function capitalizeFirst(str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}


const mapStateToProps = (state, ownProps) => {
  return {
    stops: state.otp.transitIndex.stops,
  }

}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(
  TransitLeg
)